import auth from './modules/auth'
import cloudTelephony from './modules/cloud-telephony'

export default {
    auth,
    cloudTelephony
}
